import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useTemuWorkspaceAuth } from '@/temu-platform/context/TemuWorkspaceAuthContext';
import { IPE_TEMU_GATE_PATH } from '@/temu-platform/constants/temuRoutes';
import {
  hasAuthorizedTemuShop,
} from '@/temu-platform/utils/temuShopAuthGate';

/**
 * 二次验证通过后，仍须有已授权 TEMU 店铺才可进入工作区。
 */
export default function TemuWorkspaceGuard({ children }) {
  const { t } = useTranslation('workbench');
  const { unlocked, checking, lock, workspaceShopType } = useTemuWorkspaceAuth();
  const location = useLocation();
  const [shopAuthChecking, setShopAuthChecking] = useState(false);
  const [shopAuthDenied, setShopAuthDenied] = useState(false);

  useEffect(() => {
    if (checking || !unlocked) {
      setShopAuthChecking(false);
      setShopAuthDenied(false);
      return undefined;
    }

    let cancelled = false;
    setShopAuthChecking(true);
    setShopAuthDenied(false);

    hasAuthorizedTemuShop({ shopType: workspaceShopType || undefined })
      .then(async (ok) => {
        if (cancelled) return;
        if (ok) {
          setShopAuthDenied(false);
          return;
        }
        setShopAuthDenied(true);
        try {
          await lock();
        } catch {
          /* ignore */
        }
      })
      .catch(() => {
        if (!cancelled) {
          setShopAuthDenied(true);
        }
      })
      .finally(() => {
        if (!cancelled) {
          setShopAuthChecking(false);
        }
      });

    return () => {
      cancelled = true;
    };
  }, [checking, unlocked, lock, workspaceShopType]);

  if (checking || shopAuthChecking) {
    return (
      <div className="temu-platform temu-platform--loading">
        <p>{t('platformBar.checking', { platform: 'TEMU' })}</p>
      </div>
    );
  }

  if (!unlocked || shopAuthDenied) {
    return (
      <Navigate
        to={IPE_TEMU_GATE_PATH}
        replace
        state={{
          redirect: location.pathname + location.search,
          shopAuthError: shopAuthDenied ? t('shop.enterAuthExpired') : undefined,
        }}
      />
    );
  }

  return children || <Outlet />;
}
